import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import './style.scss';
import { useRef, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import ScrollableRow from '../../ui/ScrollableRow';
import GameNavButton from '../../ui/GameNavButton';
import { useSelector } from 'react-redux';
import { selectCurrentTaskId, selectGameResults } from '../../store/slices/rallyGame';
const GameNavBar = ({ isLinearRally, onNavButtonClick }) => {
    const { t } = useTranslation();
    const gameResults = useSelector(selectGameResults);
    const currentTaskId = useSelector(selectCurrentTaskId);
    const buttonRefs = useRef([]);
    useEffect(() => {
        const index = gameResults.findIndex((task) => task.taskId === currentTaskId);
        const button = buttonRefs.current[index];
        if (button) {
            button.scrollIntoView({
                behavior: 'smooth',
                inline: 'center',
                block: 'nearest',
            });
        }
    }, [currentTaskId, gameResults]);
    const isTaskLocked = (task) => {
        const prevTask = gameResults[task.sorting - 2];
        if (!prevTask) {
            return false;
        }
        else {
            if (prevTask.status === 'completed') {
                return false;
            }
            if (prevTask.taskType === 'check-in' &&
                prevTask.answerType === 'location' &&
                prevTask.status === 'skipped') {
                return false;
            }
            return !(prevTask.taskType === 'action' &&
                prevTask.answerType === 'validated-text' &&
                prevTask.status === 'failed');
        }
    };
    return (_jsx("div", { className: "game-nav-bar", children: _jsxs(ScrollableRow, { gap: '2px', children: [_jsx(GameNavButton, { status: 'start', label: t('button.start'), disabled: true }), gameResults.map((task, index) => {
                    return (_jsx(GameNavButton, { status: task.taskId === currentTaskId ? 'pending' : task.status, label: String(task.sorting), onClick: () => {
                            onNavButtonClick(task.sorting);
                        }, disabled: task.taskId === currentTaskId || isLinearRally ? isTaskLocked(task) : false, ref: (el) => {
                            if (el) {
                                buttonRefs.current[index] = el;
                            }
                        } }, task.taskId));
                }), _jsx(GameNavButton, { status: 'end', label: t('button.end'), disabled: true })] }) }));
};
export default GameNavBar;
